// tslint:disable: no-console
import { errors } from "@renproject/interfaces";
export const useBrowserWeb3 = async () => {
    let injectedProvider;
    const web3Window = window;
    if (web3Window.ethereum) {
        await web3Window.ethereum.enable();
        injectedProvider = web3Window.ethereum;
    }
    else if (web3Window.web3) {
        injectedProvider = web3Window.web3.currentProvider;
    }
    else {
        throw new Error(errors.NO_BROWSER_WEB3);
    }
    return injectedProvider;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2ViMy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy93ZWIzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLDZCQUE2QjtBQUU3QixPQUFPLEVBQUUsTUFBTSxFQUFFLE1BQU0sd0JBQXdCLENBQUM7QUFRaEQsTUFBTSxDQUFDLE1BQU0sY0FBYyxHQUFHLEtBQUssSUFBMkIsRUFBRTtJQUM1RCxJQUFJLGdCQUFnQixDQUFDO0lBT3JCLE1BQU0sVUFBVSxHQUFHLE1BQW9CLENBQUM7SUFDeEMsSUFBSSxVQUFVLENBQUMsUUFBUSxFQUFFO1FBQ3JCLE1BQU0sVUFBVSxDQUFDLFFBQVEsQ0FBQyxNQUFNLEVBQUUsQ0FBQztRQUNuQyxnQkFBZ0IsR0FBRyxVQUFVLENBQUMsUUFBUSxDQUFDO0tBQzFDO1NBQU0sSUFBSSxVQUFVLENBQUMsSUFBSSxFQUFFO1FBQ3hCLGdCQUFnQixHQUFHLFVBQVUsQ0FBQyxJQUFJLENBQUMsZUFBZSxDQUFDO0tBQ3REO1NBQU07UUFDSCxNQUFNLElBQUksS0FBSyxDQUFDLE1BQU0sQ0FBQyxlQUFlLENBQUMsQ0FBQztLQUMzQztJQUVELE9BQU8sZ0JBQWdDLENBQUM7QUFDNUMsQ0FBQyxDQUFDIn0=